exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-389367f3] {\n  color: #0076f0 !important;\n}\na[data-v-389367f3]:hover {\n  color: #0056b3 !important;\n  cursor: pointer;\n  text-decoration: underline !important;\n}\n", ""]);

// exports
